const STORAGE_KEY = 'cvgidas_search_history';
const MAX_LOCAL = 20;

export interface SearchHistoryItem {
  id: number | string;
  title: string;
  searchParams: Record<string, string>;
  created_at: string;
}

export function getLocalSearchHistory(limit = 5): SearchHistoryItem[] {
  try {
    const items: SearchHistoryItem[] = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    return items.slice(0, limit);
  } catch { return []; }
}

export function addLocalSearchHistory(title: string, searchParams: Record<string, string>): void {
  try {
    let items: SearchHistoryItem[] = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    items = items.filter(i => i.title !== title);
    items.unshift({ id: Date.now(), title, searchParams, created_at: new Date().toISOString() });
    if (items.length > MAX_LOCAL) items = items.slice(0, MAX_LOCAL);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  } catch { /* silent */ }
}

export function removeLocalSearchHistory(id: number | string): void {
  try {
    const items: SearchHistoryItem[] = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items.filter(i => i.id !== id)));
  } catch { /* silent */ }
}

export async function saveSearchHistory(title: string, searchParams: Record<string, string>, isAuthenticated: boolean): Promise<void> {
  if (!title.trim()) return;

  if (!isAuthenticated) {
    addLocalSearchHistory(title, searchParams);
    return;
  }

  try {
    const token = localStorage.getItem('auth_token');
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
    fetch(`${API_URL}/search-history`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ title, searchParams })
    }).catch(() => {});
  } catch { /* fire and forget */ }
}

export async function fetchSearchHistory(limit = 5): Promise<SearchHistoryItem[]> {
  try {
    const token = localStorage.getItem('auth_token');
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
    const response = await fetch(`${API_URL}/search-history/my?limit=${limit}`, {
      headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' }
    });
    if (!response.ok) return [];
    const result = await response.json();
    return (result.data || []).map((r: any) => ({
      id: r.id,
      title: r.title,
      searchParams: typeof r.search_params === 'string' ? JSON.parse(r.search_params) : (r.search_params || {}),
      created_at: r.created_at
    }));
  } catch { return []; }
}

export async function deleteSearchHistory(id: number | string, isAuthenticated: boolean): Promise<void> {
  if (!isAuthenticated) {
    removeLocalSearchHistory(id);
    return;
  }
  try {
    const token = localStorage.getItem('auth_token');
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
    await fetch(`${API_URL}/search-history/${id}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` }
    });
  } catch { /* silent */ }
}
